import { defineStore } from "pinia";
import { reactive, computed } from "vue";

export const useAuthStore = defineStore("auth", () => {
  const authState = reactive({
    authenticating: false,
    authenticated: false,
    isSluiceHost: false,
    error: undefined as string | undefined,
    user: undefined as User | undefined,
  });

  const isBusinessCustomer = computed(
    () => authState.user?.isBusinessCustomer === true
  );

  const isSluiceHost = computed(
    () => authState.isSluiceHost
  );

  return {
    authState,
    isBusinessCustomer,
    isSluiceHost,
  };
});
